import { ArrowCircleUpIcon } from '@heroicons/react/outline';
import { LANG } from 'Lib/lang';
import { animateScroll as scroll } from 'react-scroll'

export default function EndOfList() {
  return (
    <div className="end-of-list flex flex-col items-center">
      <span
        className="to-the-top"
        onClick={() =>
          scroll.scrollToTop({
            smooth:true
          })
        }
      >
        <ArrowCircleUpIcon className="mb-2 h-10 w-10 stroke-1 text-violet-500" />
      </span>
      <span>{LANG.END_OF_LIST}</span>
    </div>
  );
}
